export default {
  title: {
    en: 'An offer just for you!',
  },
  text: {
    en: `We want to keep you in the Scentbird family. So we will throw <b>gift</b> to your next shipment.`,
  },
  buttonTitle: {
    primary: {
      en: 'Claim this offer',
    },
    ordinary: {
      en: 'Continue cancellation',
    },
  },
}
